import tmhRequest from '@/config/tmhRequest'

export default {

  searchCoupon: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/searchcoupon',
      method: 'post',
      params: data,
    })
  },

  searchListCoupon: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/searchlistcoupon',
      method: 'post',
      params: data,
    })
  },

  searchListZeroCoupon: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/searchlistzerocoupon',
      method: 'post',
      params: data,
    })
  },

  searchCouponCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/searchcouponcount',
      method: 'post',
      params: data,
    })
  },

  searchCouponByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/searchcouponbypage',
      method: 'post',
      params: data,
    })
  },

  addCoupon: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/addcoupon',
      method: 'post',
      data: data,
    })
  },

  editCoupon: function (data) {
    return tmhRequest({
      url: '/project/tmh/coupon/editcoupon',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/coupon.js